export const DEFAULT_SIMILAR_TITLE = 'Imóveis semelhantes';

interface PlaceSource {
  address?: unknown;
  condominium_name?: string | null;
}

export const normalizePlace = (value?: string | null): string =>
  (value || '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');

const addressField = (item: PlaceSource, field: 'neighborhood' | 'city'): string => {
  const address = item.address;
  if (!address || typeof address !== 'object') return '';
  const value = (address as Record<string, unknown>)[field];
  return typeof value === 'string' ? value.trim() : '';
};

const placeNames = (item: PlaceSource): string[] =>
  [addressField(item, 'neighborhood'), (item.condominium_name || '').trim()].filter(Boolean);

const sameCity = (a: PlaceSource, b: PlaceSource): boolean => {
  const cityA = normalizePlace(addressField(a, 'city'));
  const cityB = normalizePlace(addressField(b, 'city'));
  return !cityA || !cityB || cityA === cityB;
};

/** O backend põe o mesmo bairro/condomínio primeiro; o título só o anuncia. */
export const similarSectionTitle = (source: PlaceSource, items: PlaceSource[]): string => {
  const first = items[0];
  if (!first || !sameCity(source, first)) return DEFAULT_SIMILAR_TITLE;
  const firstKeys = new Set(placeNames(first).map(normalizePlace));
  const match = placeNames(source).find((name) => firstKeys.has(normalizePlace(name)));
  return match ? `Mais opções em ${match}` : DEFAULT_SIMILAR_TITLE;
};
